/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatDotsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABTUlEQVR4nN2VO07DQBCGA+IhejrgLG4txfMwyjIT0fsKlG5BCETJAQJC1ChcgRuASCyFKwQENChoE0cJ8kL8oslIfzP2fP9qdne20Vjq8H1/E0MxSHKNJAmwDoH0HUj7QNqx3zzPWysFB5Z9JBkg62iBXoCFirBXgPQiB3g0LyA9i+N4Nc/Kz4vCcc7kT3hAbS4Lx1SW4YRHUbRu+1nVAEkGlpUxwPBAK8M5VSjG0Xu9qcsAWK+yBqT92WbJXbNpdsLwcBdJu0VyqXrZFrF+Tn+wBdM8kewVyU0kb1kDko+6DIB16DJIZidBu7Z4XERyXyg3MXhyGOhtbZtM2vnfY4rayhgYYzZ+tKn8RUssq+EKIDmqfgfEPVmDoL2NJM8VDY6dcGPMFrA8VIPLya/jGlguK8B7Cx8cZD0Fkq+cR/AVSR7HTyZqyzk5lyq+AWm5c1lEQNRFAAAAAElFTkSuQmCC)
 */
export const ChatDotsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22 12a10 10 0 0 1-10 10H2.2a1 1 0 0 1-.75-1.66l2.06-2.37a.52.52 0 0 0 .04-.61A10 10 0 1 1 22 12Zm-10 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm7-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM7 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
